module.exports = __webpack_public_path__ + "img/feature-menu.ab0d1382.png";